import React from "react";
import { Layout, NavigationBanner, SectionList } from "../../../components";
import styles from "./MotoristsAdblue.module.scss";
import ContactUsContacts from "../../contact-us/ContactUsContacts";
import useFetchB2B from "../../../helpers/useFetchB2B";
import b2bRoutes from "../../../helpers/b2b.routes";

const MotoristsAdblue = () => {
  const { sortedSection, currentPage, pages } = useFetchB2B({
    url: b2bRoutes.MOTORISTS,
  });

  return (
    <Layout pageTitle="Engen AdBlue" withBottomPadding={false} backButton={true}>
      {currentPage ? (
        <>
          <NavigationBanner pages={pages} activePage={currentPage} />
          <div className={styles.main}>
            <SectionList sections={sortedSection} />
            <div style={{ marginTop: "10rem" }}>
              <ContactUsContacts />
            </div>
          </div>
        </>
      ) : null}
    </Layout>
  );
};

export default MotoristsAdblue;
